<form [formGroup]="form"
      (ngSubmit)="createUpdate()">

  <div class="formgrid grid">
    <div class="field col-12 mt-3">
      <label for="name"
             class="font-bold sc-required-input"
             i18n>Project Name</label>
      <input scValidatable
             id="name"
             type="text"
             pInputText
             formControlName="name"
             placeholder="Type project name"
             i18n-placeholder
             class="w-full">
    </div>
    @if (isCreate) {
      <div class="field col-12 mt-2">
        <label for="title"
               class="font-bold sc-required-input"
               i18n>ISBN</label>
        <p-autoComplete scValidatable
                        appendTo="body"
                        formControlName="title"
                        [multiple]="false"
                        [suggestions]="filteredTitles$ | async"
                        [forceSelection]="true"
                        [required]="true"
                        [minLength]="1"
                        [autoZIndex]="true"
                        [showEmptyMessage]="true"
                        (completeMethod)="filterTitles($event)"
                        dataKey="id"
                        optionLabel="name"
                        placeholder="ISBN or Title"
                        i18n-placeholder
                        inputStyleClass="w-full"
                        class="w-full">
        </p-autoComplete>
      </div>
      <div class="col-12 mt-2">
        <p-checkbox [binary]="true"
                    formControlName="onlyAcceptedPapers"
                    inputId="onlyAcceptedPapers" />
        <label for="onlyAcceptedPapers"
               class="ml-2"
               i18n>Only Accepted Papers</label>
      </div>
    }
  </div>
  <p-button scSubmitButton
            [requestInProcess]="requestInProcess"
            class="flex justify-content-center mt-3"
            [label]="isCreate ? 'Create' : 'Save'"
            i18n-label>
  </p-button>
</form>